import { useContext } from "react"

// ** Custom Components
import Box from "../../components/Box"
import Container from "../../components/Container"
import Heading from "../../components/Heading"
import StaffCard from "../../components/StaffCard"
import PageContext from "../../contexts/PageContext"

import i18n from "../../data/i18n_constants"
import { useTechTeamData } from "../../hooks/use-tech-team-data"

const TechTeamSectionCorporate = () => {
  const teamsData = useTechTeamData()
  const techResources = teamsData
    .filter((staff: any) => {
      if (staff.tags.includes("tech-resources")) {
        return staff
      }
    })
    .sort((a: any, b: any) => a.firstname.localeCompare(b.firstname))

  if (techResources.length === 0) {
    return null
  }

  const page = useContext(PageContext)
  return (
    <Container fullWidthOnMobile={false} constrainedToBreakPoint>
      <Heading as="h2" className="text-blue-500 text-center">
        {i18n.tech_resources[page.i18n_lang]}
      </Heading>
      <Box className="flex flex-wrap gap-x-6 justify-center">
        {techResources.map((staff: any) => (
          <StaffCard staff={staff} key={staff.id} />
        ))}
      </Box>
    </Container>
  )
}

export default TechTeamSectionCorporate
